import React from "react";
import { Link } from "react-router-dom";
import { useLang, IMAGES } from "../i18n";
import { Reveal, SectionLabel } from "./Motion";
import { ArrowUpRight } from "lucide-react";

export const PatentChooser = () => {
  const { t } = useLang();
  const c = t.chooser;

  return (
    <section data-testid="patent-chooser" className="relative py-20 md:py-28 border-t border-[var(--border)]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <SectionLabel>{c.label}</SectionLabel>
            <h2 className="font-cormorant font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[var(--text-primary)]">
              {c.title}
            </h2>
          </div>
          <p className="font-outfit font-light text-[var(--text-secondary)] max-w-md">{c.sub}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {c.cards.map((card, i) => (
            <Reveal key={card.link} delay={i * 0.12}>
              <Link
                to={card.link}
                data-testid={`patent-card-${i + 1}`}
                className="group relative block h-full overflow-hidden rounded-[2rem] border border-[var(--border)] min-h-[420px]"
              >
                <img
                  src={IMAGES[card.img]}
                  alt={card.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-108"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#12241b]/90 via-[#12241b]/30 to-transparent" />
                <span className="absolute top-6 left-6 w-6 h-6 border-t border-l border-[var(--gold)]/60" />
                <span className="absolute top-6 right-6 w-11 h-11 rounded-full border border-[var(--gold)]/70 bg-black/20 backdrop-blur-sm flex items-center justify-center text-[var(--gold)] transition-transform duration-500 group-hover:scale-110 group-hover:rotate-45">
                  <ArrowUpRight className="w-4 h-4" />
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10">
                  <span className="font-jetbrains text-[11px] tracking-[0.25em] text-[var(--gold)] uppercase">{card.n}</span>
                  <h3 className="font-cormorant text-3xl md:text-4xl text-white mt-3 leading-tight">{card.name}</h3>
                  <p className="font-outfit font-light text-sm text-white/70 leading-relaxed mt-3 max-w-md">{card.d}</p>
                  <span className="inline-flex items-center gap-2 mt-6 font-jetbrains text-[10px] tracking-[0.2em] uppercase text-[var(--gold)]">
                    {c.cta} <ArrowUpRight className="w-3.5 h-3.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
